// AddPlayerModal.js
import React, { useState } from 'react';

export default function AddPlayerModal({ onClose, handleAddPlayer }) {
    const [newPlayerName, setNewPlayerName] = useState('');

    const onSubmit = () => {
        if (newPlayerName.trim()) {
            handleAddPlayer(newPlayerName, setNewPlayerName, onClose);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-card rounded-lg border border-border p-6 max-w-sm w-full">
                <h3 className="text-lg font-medium text-foreground mb-4">새 선수 추가</h3>
                <input
                    type="text"
                    value={newPlayerName}
                    onChange={(e) => setNewPlayerName(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && onSubmit()}
                    placeholder="선수 이름을 입력하세요"
                    maxLength={20}
                    className="w-full px-3 py-2 bg-input border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent mb-4 text-sm text-foreground placeholder:text-muted-foreground"
                    autoFocus
                />
                <div className="flex gap-3">
                    <button
                        onClick={onSubmit}
                        disabled={!newPlayerName.trim()}
                        className="flex-1 bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/90 disabled:bg-muted-foreground text-sm"
                    >
                        추가
                    </button>
                    <button
                        onClick={() => {
                            setNewPlayerName('');
                            onClose();
                        }}
                        className="flex-1 border border-border text-foreground/80 px-4 py-2 rounded-md hover:bg-accent text-sm"
                    >
                        취소
                    </button>
                </div>
            </div>
        </div>
    );
}